// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5JpTX","headerWrappper":"Header_headerWrappper__ol0Yv","menu":"Header_menu__j3Daj","active":"Header_active__G+SZ3"};